<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>平台数据</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <div v-loading="loading.loading">

      <el-row class="mt10">
        <el-col :span="24" class="pr5 mb10">
          <el-card>
            <div slot="header" class="clearfix flex space">
              <span class="col45">能耗走势图</span>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-button-group>
                  <el-button size="mini" :autofocus="true" @click="getIndexActive(1)">本周</el-button>
                  <el-button size="mini" @click="getIndexActive(2)">本月</el-button>
                  <el-button size="mini" @click="getIndexActive(3)">本年</el-button>
                </el-button-group>
              </div>
              <div class="flex space" style="position: relative;z-index: 1">
                <el-date-picker :pickerOptions="pickerOptions" @input="getDateBill" v-model="billDate" size="mini" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </div>
            </div>
            <div id="line" style="width: 100%; height: 400px"></div>
          </el-card>
        </el-col>
      </el-row>

      <el-row class="mt10">
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>冰箱耗电走势图</span>
            </div>
            <div id="line1" style="width: 100%; height: 200px"></div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>空调耗电走势图</span>
            </div>
            <div>
              <div id="line2" style="width: 100%; height: 200px"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>洗衣机耗电走势图</span>
            </div>
            <div>
              <div id="line3" style="width: 100%; height: 200px"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>微波炉耗电走势图</span>
            </div>
            <div>
              <div id="line4" style="width: 100%; height: 200px"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row class="mt10">
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>暖风机耗电走势图</span>
            </div>
            <div id="line5" style="width: 100%; height: 200px"></div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>电磁炉耗电走势图</span>
            </div>
            <div>
              <div id="line6" style="width: 100%; height: 200px"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>室内照明耗电走势图</span>
            </div>
            <div>
              <div id="line7" style="width: 100%; height: 200px"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>其他耗电走势图</span>
            </div>
            <div>
              <div id="line8" style="width: 100%; height: 200px"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
  <style>
.el-card__header {
  height: 65px;
}
.box-cell {
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  height: 171px;
  padding: 10px 20px 20px 20px;
  background: url(/img/u122.7b61cf7c.png) no-repeat center 110px;
  background-size: 90%;
  background-color: #fff;
  border-radius: 15px;
}

.box-cell .box-icon {
  background-color: #5ad8a6;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.box-cell .box-title {
  display: flex;
  flex-direction: column;
  width: 54%;
}

.box-cell .box-title .online {
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

.box-cell .box-title .yestaday {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.box-cell .box-nums {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.box-cell .box-nums .total {
  line-height: 30px;
  font-size: 30px;
}

.box-cell .box-nums .nums {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.gl-count {
  flex: 1;
  text-align: center;
}

.gl-count p:nth-child(1) {
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 16px;
  color: #666;
}

.gl-count p:nth-child(2) {
  font-size: 38px;
  line-height: 35px;
  color: #1676eb;
  font-weight: bold;
}

.gl-count p:nth-child(2):after {
  box-sizing: border-box;
}
</style>
  <script>
import countTo from "vue-count-to";
export default {
  components: { countTo },
  data() {
    return {
      billDate: [],
      loading: {
        loading: true,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      online_days: [],
      online_series1: [],
      online_series2: [],
      online_series3: [],
      online_series4: [],
      online_series5: [],
      active_dev: "",
      online_dev: "",
      times_dev: "",
    };
  },
  created() {
    this.loading.loading = false;
  },
  mounted() {
    //this.getIndexAnalysis();
    //this.getIndexActive();
    this.drawChart();
    this.drawChart1();
    this.drawChart2();
    this.drawChart3();
    this.drawChart4();
    this.drawChart5();
    this.drawChart6();
    this.drawChart7();
    this.drawChart8();
  },
  methods: {
    getDateBill() {
      this.getIndexActive();
    },

    getIndexActive(type) {
      const that = this;
      that.axios
        .post("/get_consume_users", {
          type: type,
          times: this.billDate,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.active_dev = res.data.data;
            this.online_dev = res.data.data1;
            this.times_dev = res.data.date;
            this.drawChart1();
            this.loading.loading = false;
          } else {
            this.loading.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    getIndexAnalysis(type) {
      const that = this;
      that.axios
        .post("/get_consume_datas", {
          type: type,
          times: this.billDate,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.online_series1 = res.data.data1;
            this.online_series2 = res.data.data2;
            this.online_series3 = res.data.data3;
            this.online_series4 = res.data.data4;
            this.online_series5 = res.data.data5;
            this.online_days = res.data.date;
            this.drawChart();
            this.loading.loading = false;
          } else {
            this.loading.loading = false;
            that.$message.error(res.msg);
          }
        });
    },

    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("line"));
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [
            "冰箱",
            "空调",
            "洗衣机",
            "微波炉",
            "暖风机",
            "电磁炉",
            "室内照明",
            "其他",
          ],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "冰箱",
            type: "line",
            stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "空调",
            type: "line",
            stack: "Total",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
          {
            name: "洗衣机",
            type: "line",
            stack: "Total",
            data: [150, 232, 201, 154, 190, 330, 410],
          },
          {
            name: "微波炉",
            type: "line",
            stack: "Total",
            data: [320, 332, 301, 334, 390, 330, 320],
          },
          {
            name: "暖风机",
            type: "line",
            stack: "Total",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            name: "室内照明",
            type: "line",
            stack: "Total",
            data: [82, 93, 90, 93, 129, 133, 320],
          },
          {
            name: "其他",
            type: "line",
            stack: "Total",
            data: [20, 32, 1, 34, 90, 30, 20],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    drawChart1() {
      let myChart = this.$echarts.init(document.getElementById("line1"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart2() {
      let myChart = this.$echarts.init(document.getElementById("line2"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [320, 432, 501, 634, 790, 830, 920],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart3() {
      let myChart = this.$echarts.init(document.getElementById("line3"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [810, 922, 931, 944, 150, 160, 1020],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart4() {
      let myChart = this.$echarts.init(document.getElementById("line4"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [320, 432, 101, 134, 290, 330, 100],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart5() {
      let myChart = this.$echarts.init(document.getElementById("line5"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [660, 772, 221, 114, 880, 930, 20],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart6() {
      let myChart = this.$echarts.init(document.getElementById("line6"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [120, 532, 301, 234, 790, 230, 40],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart7() {
      let myChart = this.$echarts.init(document.getElementById("line7"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [160, 612, 341, 434, 630, 230, 420],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
    drawChart8() {
      let myChart = this.$echarts.init(document.getElementById("line8"));
      let option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [89, 45, 156, 345, 245, 201, 302],
            type: "line",
            smooth: true,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
  